import { ReactElement } from 'react'
import { P } from '@farewill/ui'

import ExternalLink from 'components/external-link'
import {
  formatToHuman,
  squareUrlForInvoicePage,
  squareUrlForTransactionPage,
  stripeUrlForInvoicePage,
  stripeUrlForTransactionPage,
} from 'utils/helpers'

const SquareLink = ({
  reference,
  paymentProviderInvoiceId,
}: {
  reference?: string
  paymentProviderInvoiceId?: string
}): ReactElement => {
  const description = 'Card payment'

  if (paymentProviderInvoiceId) {
    return (
      <ExternalLink href={squareUrlForInvoicePage(paymentProviderInvoiceId)}>
        {description}
      </ExternalLink>
    )
  }

  if (!paymentProviderInvoiceId && reference) {
    return (
      <ExternalLink href={squareUrlForTransactionPage(reference)}>
        {description}
      </ExternalLink>
    )
  }

  return <P>No Square link</P>
}

const StripeLink = ({
  reference,
  paymentProviderInvoiceId,
}: {
  reference?: string
  paymentProviderInvoiceId?: string
}): ReactElement => {
  const description = 'Card payment'

  if (reference) {
    return (
      <ExternalLink href={stripeUrlForTransactionPage(reference)}>
        {description}
      </ExternalLink>
    )
  }

  /** reference takes precedence over invoiceId - all paid invoices will have a reference, and invoiceId will be used for unpaid ones */
  if (paymentProviderInvoiceId) {
    return (
      <ExternalLink href={stripeUrlForInvoicePage(paymentProviderInvoiceId)}>
        {description}
      </ExternalLink>
    )
  }
  return <P>No Stripe link</P>
}

const PaymentLink = ({
  paymentProvider,
  reference,
  paymentProviderInvoiceId,
}: {
  paymentProvider: string
  reference?: string
  paymentProviderInvoiceId?: string
}): ReactElement => {
  if (paymentProvider === 'square') {
    return (
      <SquareLink
        reference={reference}
        paymentProviderInvoiceId={paymentProviderInvoiceId}
      />
    )
  }

  if (paymentProvider === 'stripe') {
    return (
      <StripeLink
        reference={reference}
        paymentProviderInvoiceId={paymentProviderInvoiceId}
      />
    )
  }

  return <P>No {formatToHuman(paymentProvider)} link</P>
}

export default PaymentLink
